import { render, staticRenderFns } from "./CreateShipment.vue?vue&type=template&id=1aa1c17e&scoped=true"
import script from "./CreateShipment.vue?vue&type=script&lang=js"
export * from "./CreateShipment.vue?vue&type=script&lang=js"
import style0 from "./CreateShipment.vue?vue&type=style&index=0&id=1aa1c17e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa1c17e",
  null
  
)

export default component.exports